import { render, staticRenderFns } from "./SideMenuHeaderFilter.vue?vue&type=template&id=6b19f971&scoped=true&"
import script from "./SideMenuHeaderFilter.vue?vue&type=script&lang=js&"
export * from "./SideMenuHeaderFilter.vue?vue&type=script&lang=js&"
import style0 from "./SideMenuHeaderFilter.vue?vue&type=style&index=0&id=6b19f971&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b19f971",
  null
  
)

export default component.exports